import LegalPageLayout from "@/components/LegalPageLayout";
import SEO from "@/components/SEO";

export default function CookiePolicy() {
  return (
    <>
      <SEO
        title="Cookie Policy | YourSolicitor.co.uk"
        description="Learn how YourSolicitor.co.uk uses cookies and similar technologies, and how to manage your preferences."
        canonical="/cookie-policy"
        noIndex={false}
      />
      <LegalPageLayout title="Cookie Policy" lastUpdated="January 2025">
      <p className="legal-intro">
        This Cookie Policy explains how Blue Lion Law Limited uses cookies and similar technologies on our website. By using our website, you consent to the use of cookies as described in this policy.
      </p>

      <h2>What Are Cookies?</h2>
      <p>
        Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to website owners.
      </p>

      <h2>Types of Cookies We Use</h2>

      <div className="legal-cookie-card">
        <div className="legal-cookie-header">
          <h3>Essential Cookies</h3>
          <span className="cookie-badge essential">Always On</span>
        </div>
        <p>These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.</p>
        <p><strong>Cannot be disabled</strong> — The website cannot function properly without these cookies.</p>
      </div>

      <div className="legal-cookie-card">
        <div className="legal-cookie-header">
          <h3>Analytics Cookies</h3>
          <span className="cookie-badge optional">Can be disabled</span>
        </div>
        <p>These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website.</p>
      </div>

      <div className="legal-cookie-card">
        <div className="legal-cookie-header">
          <h3>Functional Cookies</h3>
          <span className="cookie-badge optional">Can be disabled</span>
        </div>
        <p>These cookies enable enhanced functionality and personalisation, such as remembering your preferences and chat history.</p>
      </div>

      <h2>Cookies We Use</h2>
      <div className="legal-table-wrap">
        <table className="legal-table">
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Purpose</th>
              <th>Duration</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>session_id</td><td>Maintains your session</td><td>Session</td><td>Essential</td></tr>
            <tr><td>chat_session</td><td>Maintains chat history</td><td>24 hours</td><td>Functional</td></tr>
            <tr><td>_ga</td><td>Google Analytics — distinguishes users</td><td>2 years</td><td>Analytics</td></tr>
            <tr><td>cookie_consent</td><td>Stores your cookie preferences</td><td>1 year</td><td>Essential</td></tr>
          </tbody>
        </table>
      </div>

      <h2>Third-Party Tracking Cookies</h2>
      <p>When activated, our website may use the following third-party tracking technologies for advertising and conversion measurement purposes:</p>
      <ul>
        <li>Facebook Pixel (Meta)</li>
        <li>Google Ads conversion tracking</li>
        <li>TikTok Pixel</li>
        <li>Bing UET (Microsoft Advertising)</li>
        <li>ClaimsPath/Ratifi tracking pixels</li>
      </ul>
      <p>These cookies are subject to the respective third parties' privacy policies. You can manage your preferences via our cookie consent banner.</p>

      <h2>Managing Cookies</h2>
      <p>You can control and manage cookies in several ways:</p>
      <ul>
        <li><strong>Browser settings:</strong> Most browsers allow you to refuse or accept cookies, delete existing cookies, and set preferences for certain websites.</li>
        <li><strong>Our cookie banner:</strong> When you first visit our website, you can choose which optional cookies to accept.</li>
      </ul>
      <p>Please note that if you choose to block cookies, some parts of our website may not function properly.</p>

      <h2>Contact Us</h2>
      <div className="legal-contact-box">
        <div className="legal-contact-item"><strong>Email:</strong> <a href="mailto:contactus@bluelionclaims.co.uk">contactus@bluelionclaims.co.uk</a></div>
        <div className="legal-contact-item"><strong>Phone:</strong> 0208 153 0033</div>
      </div>
    </LegalPageLayout>
    </>
  );
}
